export const listHseCardsWCCreatedBy = /* GraphQL */ `
query listHseCardsWCCreatedBy($createdBy: String!) {
  listHSECards(filter: { createdBy: { eq: $createdBy } }) {
    items {
      HSEID
      id
      type
      employeeName
      dateObserved
      timeObserved
      country
      otherCountry
      locationType
      location
      externalLocationType
      externalLocation
      externalCustomer
      createdBy
      activityObserved
      businessUnit
      categoryName
      status
      categories {
        items {
          actions {
            items{
              id
              action
              CategoryName
              status
            }
          }
          id
          HSEID
          categoryName
          files
          passExist
          failExist
          comments
          furtherActionRequired
          ImmediateActionTaken
          ImmediateActionTakenDetails
        }
      }
    }
    nextToken
  }
}
`;


export const listHseCardsWCBusinessUnit = /* GraphQL */ `
query listHseCardsWCCreatedBy($businessUnit: String!) {
  listHSECards(filter: { businessUnit: { eq: $businessUnit } }) {
    items {
      HSEID
      id
      type
      employeeName
      dateObserved
      timeObserved
      country
      otherCountry
      locationType
      location
      externalLocationType
      externalLocation
      externalCustomer
      createdBy
      activityObserved
      businessUnit
      categoryName
      status
      categories {
        items {
          actions {
            items{
              id
              action
              CategoryName
              status
            }
          }
          id
          HSEID
          categoryName
          files
          passExist
          failExist
          comments
          furtherActionRequired
          ImmediateActionTaken
          ImmediateActionTakenDetails
        }
      }
    }
    nextToken
  }
}
`;

export const listHseCardsWithCategories = /* GraphQL */ `
  query ListHseCardsWithCategories(
    $limit: Int
    $nextToken: String
  ) {
    listHSECards(filter: { or: [{ status: { eq: "open" } }, { status: { eq: "assigned" } }] }, limit: $limit, nextToken: $nextToken) {
      items {
        HSEID
        id
        dateObserved
        timeObserved
        country
        otherCountry
        locationType
        location
        externalLocationType
        externalLocation
        externalCustomer
        businessUnit
        categoryName
        status
        categories {
          items {
            id
            categoryName
            actions{
              items{
                status
              }
            }
          }
        }
      }
      nextToken
    }
  }
`;

export const getHSECardWithAll = /* GraphQL */ `
  query GetHSECardWithAll($id: ID!) {
    getHSECard(id: $id) {
      HSEID
      id
      type
      employeeName
      dateObserved
      timeObserved
      country
      otherCountry
      locationType
      location
      externalLocationType
      externalLocation
      externalCustomer
      createdBy
      activityObserved
      businessUnit
      categoryName
      categories {
        items{
          id
          categoryName
          files
          passExist
          failExist
          comments
          furtherActionRequired
          ImmediateActionTaken
  	  ImmediateActionTakenDetails
          _version
          actions {
            items {
              id
              action
              assignedTo
              status
              dueDate
              CategoryName
              _version
              _deleted
              logs {
                items{
                  id
                  personnelName
                  createdAt
                  logDetails
                  files
                }
              }
            }
          }
          items{
            items{
              itemName
              observation
            }
          }
        }
        nextToken
        startedAt
        __typename
      }
      lifeSavingRules
      status
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;


export const listActionsWE = /* GraphQL */ `
  query ListActions(
    $limit: Int
    $nextToken: String
  ) {
    listActions(filter: { not: { status: { eq: "closed" } }, and: { not: { status: { eq: "void" } } } }, limit: $limit, nextToken: $nextToken) {
      items {
        id
        CATID
        CategoryName
        HSEID
        action
        assignedTo
        status
        dueDate
        Category{
          id
          HSECard{
            id
            HSEID
            locationType
            location
            externalLocationType
            externalLocation
            dateObserved
            createdBy
          }
        }
        logs {
          items{
            personnelName
            createdAt
            logDetails
            files
          }
        }
        _delete
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryActionsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
/* or: [
        { status: { eq: "assigned" } },
        { status: { eq: "reassigned" } }
      ] */
export const listActionsByAssignedTo = /* GraphQL */ `
  query ListActionsByAssignedTo($assignedTo: String!) {
    listActions(filter: {
      assignedTo: { eq: $assignedTo }
    }) {
      items {
        id
        CATID
        CategoryName
        HSEID
        action
        assignedTo
        status
        dueDate
        originalDueDate
        logs{
          items{
            id
            logDetails
            personnelName
            createdAt
          }
        }
        Category{
          id
          HSECard{
            id
            HSEID
            locationType
            location
            externalLocationType
            externalLocation
            dateObserved
          }
        }
        _delete
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryActionsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;



/* Hazard Queries */
export const listHZDCardsCreatedByTest = /* GraphQL */ `
query listHZDCardsCreatedBy($createdBy: String!) {
  listHazards(filter: { createdBy: { eq: $createdBy } }) {
    items {
      id
      HZDID
      dateObserved
      businessUnit
      location
      observationType
      status
      createdBy
      actions{
        items{
          id
          action
          status
        }
      }
    }
    nextToken
  }
}
`;

export const listHZDCardsCreatedBy = /* GraphQL */ `
query listHZDCardsCreatedBy($createdBy: String! $limit: Int $nextToken: String) {
  listHazards(filter: { createdBy: { eq: $createdBy } }, limit: $limit, nextToken: $nextToken) {
    items {
      id
      HZDID
      dateObserved
      businessUnit
      location
      observationType
      observationDescription
      status
      createdBy
      actions{
        items{
          id
          action
          businessUnit
          status
          assignedTo
        }
      }
    }
    nextToken
  }
}
`;


export const listHZDCardsCreatedByEmail = /* GraphQL */ `
query listHZDCardsCreatedByEmail($createdByEmail: String!) {
  listHazards(filter: { createdByEmail: { eq: $createdByEmail } }) {
    items {
      id
      HZDID
      dateObserved
      businessUnit
      location
      observationType
      status
      createdBy
      createdByEmail
      actions{
        items{
          id
          action
          status
        }
      }
    }
    nextToken
  }
}
`;

export const listHZDCardWithAll = /* GraphQL */ `
query listHZDCardWithAll($id: ID!) {
  getHazard(id: $id) {
    id
    HZDID
    employee
    employeeName
    dateObserved
    timeObserved
    businessUnit
    locationType
    location
    externalLocationType
    externalLocation
    externalCustomer
    country
    otherCountry
    observationType
    observationDescription
    observationCategory
    immediateActionTaken
    immediateActionTakenDetails
    furtherActionRequired
    status
    justification
    createdBy
    createdByEmail
    closeDate
    files
    actions {
      items{
        id
        action
        _version
        logs{
          items{
            id
            personnelName
            createdAt
            logDetails
            files
          }
        }
        assignedTo
        status
        dueDate
        originalDueDate
        assignedToEmail
        completedDate
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const listHZDCardsWCBusinessUnit = `
query listHZDCardsWCBusinessUnit($businessUnit: String! $limit: Int $nextToken: String) {
  listHazards(filter: { 
      businessUnit: { eq: $businessUnit },
      employee: { ne: "anonymous" }, 
    },
    limit: $limit,
    nextToken: $nextToken
  ) {
    items {
      id
      HZDID
      dateObserved
      businessUnit
      location
      observationType
      observationDescription
      status
      createdBy
      actions {
        items {
          id
        }
      }
    }
    nextToken
  }
}
`;

export const listHZDCardsWCBusinessUnitQhsseUsers = `
query listHZDCardsWCBusinessUnitQhsseUsers($limit: Int $nextToken: String) {
  listHazards(filter: { 
      or: [
        { businessUnit: { eq: "QHSSE" } },
        { businessUnit: { eq: "HSSE" } }
      ],
      employee: { ne: "anonymous" }, 
    },
    limit: $limit,
    nextToken: $nextToken
  ) {
    items {
      id
      HZDID
      dateObserved
      businessUnit
      location
      observationType
      observationDescription
      status
      createdBy
      actions {
        items {
          id
        }
      }
    }
    nextToken
  }
}
`;


export const listHZDCardsOpen = /* GraphQL */ `
query listHZDCardsOpen (
    $limit: Int
    $nextToken: String
) {
    listHazards(filter: { or: [{ status: { eq: "open" } }, { status: { eq: "assigned" } }] }, limit: $limit, nextToken: $nextToken) {
    items {
      id
      HZDID
      dateObserved
      observationDescription
      businessUnit
      location
      observationType
      employee
      status
      createdBy
      actions{
        items{
          id
          status
        }
      }
    }
    nextToken
  }
}
`;

export const listHZDCardsOpenTest = /* GraphQL */ `
query listHZDCardsOpen (
    $limit: Int
    $nextToken: String
) {
    listHazards(filter: { or: [{ status: { eq: "opengg" } }, { status: { eq: "assigned23" } }] }, limit: $limit, nextToken: $nextToken) {
    items {
      id
      HZDID
      dateObserved
      businessUnit
      location
      observationType
      status
      createdBy
      actions{
        items{
          id
          status
        }
      }
    }
    nextToken
  }
}
`;



export const listHZDActionsWE = /* GraphQL */ `
  query listHZDActionsWE(
    $limit: Int
    $nextToken: String
  ) {
    listHazardActions(filter: { not: { status: { eq: "closed" } }, and: { not: { status: { eq: "void" } } } }, limit: $limit, nextToken: $nextToken) {
      items {
        id
        HZDID
        action
        assignedTo
        businessUnit
        status
        dueDate
        Hazard{
          id
          HZDID
          location
          createdBy
          dateObserved
          observationType
        }
        hazardActionsId
      }
      nextToken
      startedAt
      __typename
    }
  }
`;


export const listHazardActionsByAssignedTo = /* GraphQL */ `
  query listHazardActionsByAssignedTo($assignedTo: String! $limit: Int $nextToken: String) {
    listHazardActions(filter: { assignedTo: { eq: $assignedTo }}, limit: $limit, nextToken: $nextToken) {
      items {
        id
        HZDID
        action
        assignedTo
        businessUnit
        status
        dueDate
        originalDueDate
        Hazard{
          id
          HZDID
          locationType
          location
          externalLocationType
          externalLocation
          dateObserved
        }
        _delete
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        hazardActionsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;


export const listHazardActionsByAssignedToTeam = /* GraphQL */ `
  query listHazardActionsByAssignedTo($businessUnit: String! $limit: Int $nextToken: String) {
    listHazardActions(filter: { businessUnit: { eq: $businessUnit }}, limit: $limit, nextToken: $nextToken) {
      items {
        id
        HZDID
        action
        assignedTo
        businessUnit
        status
        dueDate
        originalDueDate
        Hazard{
          id
          HZDID
          locationType
          location
          externalLocationType
          externalLocation
          dateObserved
        }
        _delete
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        hazardActionsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;


export const listEmployeeUsers = `
    query listEmployees($limit: Int, $nextToken: String) {
      listEmployees(limit: $limit, nextToken: $nextToken) {
        items {
          Id
          FirstName
          LastName
          FullName
          OrgUnit
          JobTitle
          Email
          GlobalID
          Manager
          ManagerEmail
        }
        nextToken
      }
    }
  `